<template>
	<div class="mt10">
		<div v-if="allSpinning"
			style="width:100%;height:100%;position: fixed;left: 0;top: 0;background:rgba(0,0,0,0.6);z-index: 999999;display:flex;justify-content: center;align-items: center;">
			<a-spin :allSpinning="allSpinning" tip="加载中" :delay="100" size="large"></a-spin>
		</div>

		<!-- 报警事件_需要关注的老人 -->
		<div class="bjThing">
			<!-- 左侧守护数量等 -->
			<div class="guardWrap" v-if="new_bjAllData">
				<div class="guardList">
					<img class="gImg" src="../../../assets/home_icon_quantity_d.png" alt="">
					<div class="gNum">{{ new_bjAllData.bedCount }}</div>
					<div class="gNumName">守护老人数量</div>
				</div>
				<div class="guardList mt10">
					<img class="gImg" src="../../../assets/home_icon_days_d.png" alt="">
					<div class="gNum">{{ new_bjAllData.bedDays }}</div>
					<div class="gNumName">守护老人天数</div>
				</div>
			</div>
			<!-- 报警事件1_7 -->
			<div class="bjLeft ml10" style="width:585px;">
				<div class="b_comTopCont" v-if="bj_nowSelWhat == 1 && oneData">
					<div class="dayNum">{{ oneData.startDate | dataChange(oneData.startDate) }}</div>
					<div class="dayName">|</div>
					<div class="dayName">发生过危险报警的长者</div>
					<div class="count" v-if="oneData.totleCount == 0">{{ oneData.totleCount }}次</div>
					<div class="countRed" v-if="oneData.totleCount != 0">{{ oneData.totleCount }}次</div>
					<div class="flex" style="margin-left: auto;">
						<div :class="['dayBtn', bj_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="bj_nowSelWhat = 1">当日</div>
						<div :class="['dayBtn ml10', bj_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="bj_nowSelWhat = 7">最近7天</div>
					</div>
				</div>
				<div class="b_comTopCont" v-if="bj_nowSelWhat == 7 && weekData">
					<div class="dayNum">&nbsp;</div>
					<div class="dayName" style="margin-left: -5px;">发生过危险报警的长者</div>
					<div class="count" v-if="weekData.totleCount == 0">{{ weekData.totleCount }}次</div>
					<div class="countRed" v-if="weekData.totleCount != 0">{{ weekData.totleCount }}次</div>
					<div class="dayRange">{{ weekData.startDate | dataChange(weekData.startDate) }}~{{ weekData.endDate |
						dataChange(weekData.endDate) }}</div>
					<div class="flex" style="margin-left: auto;">
						<div :class="['dayBtn', bj_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="bj_nowSelWhat = 1">当日</div>
						<div :class="['dayBtn ml10', bj_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="bj_nowSelWhat = 7">最近7天</div>
					</div>
				</div>
				<!-- 有数据情况 -->
				<div
					v-show="(bj_nowSelWhat == 1 && oneData && oneData.resultFlag) || (bj_nowSelWhat == 7 && weekData && weekData.resultFlag)">
					<!-- <div v-show="true"> -->
					<div class="btn_RB_see" @click="cli_bjEveAll()">查看全部</div>
					<!-- 单日 -->
					<div v-show="bj_nowSelWhat == 1">
						<div class="flex bjOneDay" v-if="oneData">
							<!-- 表格部分 -->
							<div class="oldState">
								<!-- 一个 -->
								<div class="o_table border_no" v-if="oneData.homeAlarmEventTypeList.length == 1">
									<div class="o_tableList border_4444" :key="index"
										v-for="(item, index) in oneData.homeAlarmEventTypeList">
										<div class="o_name" v-if="item.type == 9">卫生间<br>停留过久</div>
										<div class="o_name" v-if="item.type != 9">{{ item.typeName }}</div>
										<div class="o_num">{{ item.count }}次</div>
									</div>
								</div>
								<!-- 两个 -->
								<div class="o_table border_no" v-if="oneData.homeAlarmEventTypeList.length == 2">
									<div class="o_tableList" :key="index" v-for="(item, index) in oneData.homeAlarmEventTypeList">
										<div class="o_name" v-if="item.type == 9">卫生间<br>停留过久</div>
										<div class="o_name" v-if="item.type != 9">{{ item.typeName }}</div>
										<div class="o_num">{{ item.count }}次</div>
									</div>
								</div>
								<!-- 三个或四个 -->
								<div class="o_table border_no o_table_Three" v-if="oneData.homeAlarmEventTypeList.length > 2">
									<div :key="index" v-for="(item, index) in oneData.homeAlarmEventTypeList">
										<div class="o_tableList" v-if="index < 3">
											<div class="o_name" v-if="item.type == 9">卫生间<br>停留过久</div>
											<div class="o_name" v-if="item.type != 9">{{ item.typeName }}</div>
											<div class="o_num">{{ item.count }}次</div>
										</div>
										<div class="o_tableList" v-if="index == 3">
											<div class="o_name">...</div>
											<div class="o_num">&nbsp;</div>
										</div>
									</div>
								</div>

							</div>
							<!-- 床位列表 -->
							<div class="bedWrap ml10">
								<div class="bedLine"></div>
								<div class="bedList" :key="index" v-for="(item, index) in oneData.homeAlarmBedNameList"
									@click="open_bjSingleTan(item)">
									<div class="bedName">{{ item.buAndFlName }}</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 七日 -->
					<div v-show="bj_nowSelWhat == 7">
						<div class="flex bjSevenDay">
							<div class="bjContWrap">
								<div class="bjEcWrap">
									<div id="ec_id_bjbl"></div>
									<div class="bjEcTip2">报警事件发生比例</div>
									<div class="bjEcTip"
										v-if="weekData && weekData.moreDayRedioList && weekData.moreDayRedioList.describe == '有上升趋势，护理人员需要提高警惕'">
										{{ weekData.moreDayRedioList.describe }}</div>
									<div class="bjEcTip bjEcTip_bgEBECEF"
										v-if="weekData && weekData.moreDayRedioList && weekData.moreDayRedioList.describe != '有上升趋势，护理人员需要提高警惕'">
										{{ weekData.moreDayRedioList.describe }}</div>
								</div>
							</div>
							<!-- 表格部分 -->
							<div class="oldState ml10" v-if="weekData">
								<!-- 一个 -->
								<div class="o_table border_no" v-if="weekData.homeAlarmEventTypeList.length == 1">
									<div class="o_tableList border_4444" :key="index"
										v-for="(item, index) in weekData.homeAlarmEventTypeList">
										<div class="o_name" v-if="item.type == 9">卫生间<br>停留过久</div>
										<div class="o_name" v-if="item.type != 9">{{ item.typeName }}</div>
										<div class="o_num">{{ item.count }}次</div>
									</div>
								</div>
								<!-- 两个 -->
								<div class="o_table border_no" v-if="weekData.homeAlarmEventTypeList.length == 2">
									<div class="o_tableList" :key="index" v-for="(item, index) in weekData.homeAlarmEventTypeList">
										<div class="o_name" v-if="item.type == 9">卫生间<br>停留过久</div>
										<div class="o_name" v-if="item.type != 9">{{ item.typeName }}</div>
										<div class="o_num">{{ item.count }}次</div>
									</div>
								</div>
								<!-- 三个或四个 -->
								<div class="o_table border_no o_table_Three" v-if="weekData.homeAlarmEventTypeList.length > 2">
									<div :key="index" v-for="(item, index) in weekData.homeAlarmEventTypeList">
										<div class="o_tableList" v-if="index < 3">
											<div class="o_name" v-if="item.type == 9">卫生间<br>停留过久</div>
											<div class="o_name" v-if="item.type != 9">{{ item.typeName }}</div>
											<div class="o_num">{{ item.count }}次</div>
										</div>
										<div class="o_tableList" v-if="index == 3">
											<div class="o_name">...</div>
											<div class="o_num">&nbsp;</div>
										</div>
									</div>
								</div>

							</div>
							<!-- 床位列表 -->
							<div class="bedWrap ml10" style="width: 162px;" v-if="weekData">
								<!-- <div class="bedLine"></div> -->
								<div class="bedList" :key="index" v-for="(item, index) in weekData.homeAlarmBedNameList"
									@click="open_bjSingleTan(item)">
									<div class="bedName" style="width:132px;">{{ item.buAndFlName }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				<!-- 无数据情况 -->
				<div class="noData mt10" style="height:194px;"
					v-show="(bj_nowSelWhat == 1 && oneData && !oneData.resultFlag) || (bj_nowSelWhat == 7 && weekData && !weekData.resultFlag)">
					<div class="" v-if="bj_nowSelWhat == 1 && oneData">
						<!-- {{ oneData.usageDscription }}<br>{{ oneData.offLineDscription }} -->
						{{ oneData.usageDscription }}
					</div>
					<div class="" v-if="bj_nowSelWhat == 7 && weekData">
						<!-- {{ weekData.usageDscription }}<br>{{ weekData.offLineDscription }} -->
						{{ weekData.usageDscription }}
					</div>
				</div>
			</div>
			<!-- 需关注老人1_7 -->
			<div class="bjLeft ml10" id="xgzHover" style="width:474px;" v-if="new_gzOldData">
				<div class="blueShu"></div>
				<div class="b_comTopCont" v-if="gzOld_nowSelWhat == 1">
					<div class="flex" style="width:270px;overflow:hidden;">
						<!-- <marquee class="left-scroll" behavior="scroll" direction="left"> -->
						<div :class="['flex dCoWrap', iswordsRoll ? 'wordsRoll' : '']">
							<!-- <div :class="['flex dCoWrap',iswordsRoll ? '' : '']"> -->
							<div class="dayNum dayNum_noAfter">{{ new_gzOldData.startDate | dataChange(new_gzOldData.startDate) }}</div>
							<div class="dayName">|</div>
							<div class="dayName">健康发生变化的长者</div>
							<div class="count" v-if="new_gzOldData.totleCount == 0">{{ new_gzOldData.totleCount }}位</div>
							<div class="countRed" v-if="new_gzOldData.totleCount != 0">{{ new_gzOldData.totleCount }}位</div>
						</div>
						<!-- </marquee> -->

					</div>
					<div class="flex" style="margin-left: auto;">
						<div :class="['dayBtn', gzOld_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(1)">当日</div>
						<div :class="['dayBtn ml10', gzOld_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(7)">最近7天
						</div>
					</div>
				</div>
				<div class="b_comTopCont" v-if="gzOld_nowSelWhat == 7">
					<div class="flex" style="width:270px;overflow:hidden;">
						<div :class="['flex dCoWrap', iswordsRoll ? 'wordsRoll' : '']">
							<div class="dayNum dayNum_noAfter">&nbsp;</div>
							<div class="dayName" style="margin-left: -5px;">健康发生变化的长者</div>
							<div class="count" v-if="new_gzOldData.totleCount == 0">{{ new_gzOldData.totleCount }}位</div>
							<div class="countRed" v-if="new_gzOldData.totleCount != 0">{{ new_gzOldData.totleCount }}位</div>
							<div class="dayRange flex_Cen_Cen">{{ new_gzOldData.startDate | dataChange(new_gzOldData.startDate) }}~{{
								new_gzOldData.endDate | dataChange(new_gzOldData.endDate) }}</div>
						</div>
					</div>
					<div class="flex" style="margin-left: auto;">
						<div :class="['dayBtn', gzOld_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(1)">当日</div>
						<div :class="['dayBtn ml10', gzOld_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(7)">最近7天
						</div>
					</div>
				</div>

				<!-- 有数据情况 -->
				<div v-if="new_gzOldData.resultFlag">
					<!-- 单日 -->
					<div v-show="gzOld_nowSelWhat == 1">
						<div class="btn_RB_see" @click="cli_gzListAll(1)">查看全部</div>
						<div class="flex bjOneDay">
							<!-- 床位列表 -->
							<div class="bedWrap" style="width:434px;">
								<div class="bedLine"></div>
								<div :key="index" v-for="(item, index) in new_gzOldData.needFollowPageListVoList"
									@click="open_tan_needGZ_single(item)">
									<div class="bedList" v-if="index < 12">
										<div class="bedName" style="width:159px;">{{ item.buAndFlName }}</div>
										<div class="bedNum colorFF7186">{{ item.total }}项</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 七日 -->
					<div v-show="gzOld_nowSelWhat == 7">
						<div class="btn_RB_see" @click="cli_gzListAll(7)">查看全部</div>
						<div class="flex bjSevenDay">
							<div class="bjContWrap">
								<div class="bjEcWrap">
									<div id="ec_id_bjbl2"></div>
									<div class="bjEcTip2">需关注的老人比例</div>
									<div class="bjEcTip"
										v-if="new_gzOldData.moreDayRedioList && new_gzOldData.moreDayRedioList.describe == '有上升趋势，护理人员需要提高警惕'">
										{{ new_gzOldData.moreDayRedioList.describe }}</div>
									<div class="bjEcTip bjEcTip_bgEBECEF"
										v-if="new_gzOldData.moreDayRedioList && new_gzOldData.moreDayRedioList.describe != '有上升趋势，护理人员需要提高警惕'">
										{{ new_gzOldData.moreDayRedioList.describe }}</div>
								</div>
							</div>
							<!-- 床位列表 -->
							<div class="bedWrap ml10" style="width: 233px;">
								<div :key="index" v-for="(item, index) in new_gzOldData.needFollowPageListVoList"
									@click="open_tan_needGZ_single(item)">
									<div class="bedList" v-if="index < 6">
										<div class="bedName" style="width:175px;">{{ item.buAndFlName }}</div>
										<div class="bedNum colorFF7186">{{ item.total }}天</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

				<!-- 无数据情况 -->
				<div class="noData mt10" style="height:194px;" v-show="!new_gzOldData.resultFlag">
					<div class="">{{ new_gzOldData.usageDscription }}</div>
				</div>
			</div>
		</div>





		<!-- 报警事件_睡眠整体情况 -->
		<div class="bjThing mt10">
			<!-- 报警事件 -->
			<div class="bjLeft">
				<div class="b_comTopCont">
					<div class="dayNum">最近30天</div>
					<div class="dayName">|</div>
					<div class="dayName">报警事件</div>
					<div class="count" v-if="moonData && moonData.totleCount == 0">{{ moonData.totleCount }}次</div>
					<div class="countRed" v-if="moonData && moonData.totleCount != 0">{{ moonData.totleCount }}次</div>
					<div class="seeTh" @click="cli_bjEveAll(30)" v-if="moonData && moonData.totleCount != 0">查看事件</div>


				</div>

				<!-- 有数据情况 -->
				<div class="bjContWrap" v-show="moonData && moonData.resultFlag">
					<div class="bjEcWrap">
						<div id="ec_id_bjbl3"></div>
						<div class="bjEcTip2">报警事件发生比例</div>
						<div class="bjEcTip"
							v-if="moonData && moonData.moreDayRedioList && moonData.moreDayRedioList.describe == '有上升趋势，护理人员需要提高警惕'">
							{{ moonData.moreDayRedioList.describe }}</div>
						<div class="bjEcTip bjEcTip_bgEBECEF"
							v-if="moonData && moonData.moreDayRedioList && moonData.moreDayRedioList.describe != '有上升趋势，护理人员需要提高警惕'">
							{{ moonData.moreDayRedioList.describe }}</div>
					</div>
					<div class="flex">
						<div id="ec_id_lcbj"></div>
						<div id="ec_id_lcbj2"></div>
					</div>
				</div>

				<!-- 无数据情况 -->
				<div class="noData" style="height:194px;" v-if="moonData && !moonData.resultFlag">
					<div class="">一切安好，暂无报警</div>
				</div>
			</div>

			<!-- 睡眠整体情况 -->
			<div class="bjLeft ml10" style="width:534px;">
				<div class="b_comTopCont">
					<div class="dayNum">最近30天</div>
					<div class="dayName">|</div>
					<div class="dayName">睡眠整体情况</div>
					<!-- <div class="count">0次</div>
          <div class="countRed">333次</div> -->
					<div class="seeTh" @click="seeSleepTan" v-if="sleepSituation_data && sleepSituation_data.resultFlag">查看异常</div>
				</div>
				<!-- 有数据情况 -->
				<div v-show="sleepSituation_data && sleepSituation_data.resultFlag">
					<div class="bjContWrap">
						<div class="flex">
							<div id="ec_id_smdf"></div>
							<div id="ec_id_smsc"></div>
							<div id="ec_id_ddfxzs"></div>
						</div>
					</div>
					<div class="sleepNameWrap">
						<div class="sleepName">睡眠得分</div>
						<div class="sleepName">睡眠时长</div>
						<div class="sleepName">跌到风险指数</div>
					</div>
				</div>


				<!-- 无数据情况 -->
				<div class="noData" style="height:194px;" v-show="sleepSituation_data && !sleepSituation_data.resultFlag">
					<div class="">睡眠设备赶紧用起来才能看到更多内容哦</div>
				</div>
			</div>
		</div>




		<!-- 弹窗_报警列表 -->
		<a-modal :title="'睡眠报告'" :visible="bjEventAllTan" :maskClosable="false" @cancel="bjEventAllTan = false"
			:dialog-style="{ 'min-width': '900px', 'max-width': '900px' }" :footer="null" id="viewBox">
			<div class="needGZ_TanWrap" v-if="bjEventAllTan && AlarmEveCount">
				<div class="needGZ_Tan">
					<div class="needGZ_Top" v-if="selectDateType == 1">
						<div class="time">{{ AlarmEveCount.startDate | dataChange(AlarmEveCount.startDate) }}</div>
						<div class="time2">&nbsp;/&nbsp;</div>
						<div class="time2">报警事件</div>
						<div class="num" v-if="AlarmEveCount.totleCount == 0">{{ AlarmEveCount.totleCount }}次</div>
						<div class="numRed" v-if="AlarmEveCount.totleCount != 0">{{ AlarmEveCount.totleCount }}次</div>
						<div class="chazi" @click="bjEventAllTan = false">X</div>
					</div>
					<div class="needGZ_Top" v-if="selectDateType == 7">
						<div class="time2">报警事件</div>
						<div class="num" v-if="AlarmEveCount.totleCount == 0">{{ AlarmEveCount.totleCount }}次</div>
						<div class="numRed" v-if="AlarmEveCount.totleCount != 0">{{ AlarmEveCount.totleCount }}次</div>
						<div class="time3">{{ AlarmEveCount.startDate | dataChange(AlarmEveCount.startDate) }}-{{ AlarmEveCount.endDate |
							dataChange(AlarmEveCount.endDate) }}</div>
						<div class="chazi" @click="bjEventAllTan = false">X</div>
					</div>
					<div class="needGZ_Top" v-if="selectDateType == 30">
						<div class="time">最近30天</div>
						<div class="time2">&nbsp;/&nbsp;</div>
						<div class="time2">报警事件</div>
						<div class="num" v-if="AlarmEveCount.totleCount == 0">{{ AlarmEveCount.totleCount }}次</div>
						<div class="numRed" v-if="AlarmEveCount.totleCount != 0">{{ AlarmEveCount.totleCount }}次</div>
						<div class="chazi" @click="bjEventAllTan = false">X</div>
					</div>

					<div class="needGZ_Cont">
						<div class="tabTime" v-if="selectDateType == 1 || selectDateType == 7">
							<div :class="['tabList', selectDateType == 1 ? 'tabListSel' : '']" @click="clc_bjEventAllTan_type(1)">当日
							</div>
							<div :class="['tabList', selectDateType == 7 ? 'tabListSel' : '']" @click="clc_bjEventAllTan_type(7)">最近7天
							</div>
						</div>

						<div class="policeWrap" v-if="AlarmEveCount && AlarmEveCount.moreDayRedioList && selectDateType == 7">
							<div class="policeTit">{{ AlarmEveCount.moreDayRedioList.describe }}</div>
							<div id="tan_list_ec_Seven_pocThing" key="myChartsl19" style="height: 110px;"></div>
							<div class="poliProporte">报警事件发生比例</div>
						</div>

						<!-- 单日七天三十天共用 -->
						<div class="topListWrap">
							<div :class="['topList', item.isSelect ? 'topListSel' : '']" style="width: auto;" :key="index"
								v-for="(item, index) in AlarmEveCount.homeAlarmEventTypeList" @click="clc_topList(index, item.type)">
								<div class="name">{{ item.typeName }}</div>
								<div class="num">{{ item.count }}次</div>
							</div>
						</div>

						<!-- 单日七天共用 -->
						<div class="oldPeople"
							v-if="(selectDateType == 1 || selectDateType == 7) && AlarmEvePageList && AlarmEvePageList.records.length != 0">
							<div class="oldList">
								<div :key="index2" v-for="(item2, index2) in AlarmEvePageList.records" @click="open_bjSingleTan(item2)">
									<div class="oldList2" v-if="index2 < 7">
										<img class="peoImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
										<div class="oldManName">{{ item2.buAndFlName }}</div>
									</div>
								</div>
							</div>
							<div class="oldList">
								<div :key="index2" v-for="(item2, index2) in AlarmEvePageList.records" @click="open_bjSingleTan(item2)">
									<div class="oldList2" v-if="index2 > 6 && index2 < 14">
										<img class="peoImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
										<div class="oldManName">{{ item2.buAndFlName }}</div>
									</div>
								</div>
							</div>
							<div class="oldList">
								<div :key="index2" v-for="(item2, index2) in AlarmEvePageList.records" @click="open_bjSingleTan(item2)">
									<div class="oldList2" v-if="index2 > 13 && index2 < 21">
										<img class="peoImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
										<div class="oldManName">{{ item2.buAndFlName }}</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 三十天表格 -->
						<div v-if="selectDateType == 30">
							<table class="bjTable" v-if="AlarmEvePageList">
								<tr>
									<td :style="{ width: item.name == '床位' ? '235px' : '' }" :key="index"
										v-for="(item, index) in AlarmEveTableArr" @click="cli_tan_bjList_table(item.sortField)">
										<div class="flex_Cen_Cen">
											<!--  -->
											<div>{{ item.name }}</div>
											<div class="ml5">
												<img class="tableIcon" v-if="tan_bjList_sortField == '' || item.sortField != tan_bjList_sortField"
													src="../../../assets/tableIcon.png" alt="">
												<img class="tableIcon"
													v-if="item.sortField == tan_bjList_sortField && tan_bjList_sortOrder == 'ascend'"
													src="../../../assets/tableIcon1.png" alt="">
												<img class="tableIcon"
													v-if="item.sortField == tan_bjList_sortField && tan_bjList_sortOrder == 'descend'"
													src="../../../assets/tableIcon2.png" alt="">
											</div>
										</div>
									</td>
								</tr>
								<tr :key="index" v-for="(item, index) in AlarmEvePageList.records">
									<td>{{ item.buAndFlName }} · {{ item.total }}次</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 1">{{ item.breathSlowCount }}
									</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 1">{{ item.breathFastCount }}
									</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 1">{{ item.heartSlowCount }}</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 1">{{ item.heartFastCount }}</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 1">{{ item.outBedLongTimeCount }}
									</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 2">{{ item.fallCount }}</td>
									<td v-if="AlarmEveCount.deviceClass == 0 || AlarmEveCount.deviceClass == 2">{{ item.fallLongCount }}</td>
								</tr>
							</table>
						</div>

						<div v-if="AlarmEvePageList">
							<a-pagination v-model="pageNum" @change="pageChange" :total="AlarmEvePageList.total" :pageSize="pageSize"
								:hideOnSinglePage="true" show-less-items style="text-align: center;"
								:class="[selectDateType == 30 ? 'mt10' : 'mt20']" />
						</div>
					</div>
				</div>
			</div>
		</a-modal>
		<!-- 弹窗_报警单人详情 -->
		<div style="z-index: 100000 !important;">
			<a-modal :title="'睡眠报告'" :visible="tan_bjSingle_show" :maskClosable="false" @cancel="tan_bjSingle_show = false"
				:dialog-style="{ 'min-width': '600px', 'max-width': '600px' }" :footer="null" id="viewBox">
				<div class="needGZ_TanWrap" v-if="tan_bjSingle_show && tan_bjSingle_allData" style="z-index: 10001 !important;">
					<div class="needGZ_Tan bgF3F4F7" style="width: 600px;">
						<div class="needGZ_Top" v-if="tan_bjSingle_selType == 1">
							<div class="time">{{ oneData.startDate | dataChange(oneData.startDate) }}</div>
							<div class="time2">&nbsp;/&nbsp;</div>
							<div class="time2">{{ tan_bjSingle_title }}</div>
							<div class="chazi" @click="tan_bjSingle_show = false">X</div>
						</div>
						<div class="needGZ_Top" v-if="tan_bjSingle_selType == 7">
							<div class="time2">{{ tan_bjSingle_title }}</div>
							<div class="time3 ml10">{{ weekData.startDate | dataChange(weekData.startDate) }}~{{ weekData.endDate |
								dataChange(weekData.endDate) }}</div>
							<div class="chazi" @click="tan_bjSingle_show = false">X</div>
						</div>
						<div class="needGZ_Cont">
							<div class="tabTime" v-if="tan_bjSingle_selType == 1 || tan_bjSingle_selType == 7">
								<div :class="['tabList', tan_bjSingle_selType == 1 ? 'tabListSel' : '']" @click="clc_bjSingleTan_type(1)">
									当日</div>
								<div :class="['tabList', tan_bjSingle_selType == 7 ? 'tabListSel' : '']" @click="clc_bjSingleTan_type(7)">
									最近7天</div>
							</div>
							<div v-if="tan_bjSingle_allData.records">
								<div class="bjSingleList" :key="index" v-for="(item, index) in tan_bjSingle_allData.records">
									<div class="bjSingleList_topCont">
										<!-- 呼吸过弱过速 -->
										<img class="abnormal_icon" v-if="item.type == 4 || item.type == 5"
											src="../../../assets/tan_bjSingle2.png" alt="">
										<!-- 心动过缓过速 -->
										<img class="abnormal_icon" v-if="item.type == 7 || item.type == 8"
											src="../../../assets/tan_bjSingle1.png" alt="">
										<!-- 跌倒 -->
										<img class="abnormal_icon" v-if="item.type == 2" src="../../../assets/tan_bjSingle3.png" alt="">
										<!-- 卫生间停留过久 -->
										<img class="abnormal_icon" v-if="item.type == 9" src="../../../assets/tan_bjSingle4.png" alt="">
										<!-- 离床过久 -->
										<img class="abnormal_icon" v-if="item.type == 1" src="../../../assets/tan_bjSingle5.png" alt="">
										<div class="ml10">
											<div class="abName">{{ item.eventName }}</div>
											<div class="abTime">{{ item.time }}</div>
										</div>
										<div class="abTime mlAuto">{{ item.dateCn | dataChange2(item.dateCn) }}</div>
									</div>
								</div>
							</div>


						</div>

						<div class="sleepFenYeWrap mt20" v-if="tan_bjSingle_allData.records">
							<a-pagination v-model="tan_bjSingle_pageNum" @change="tan_bjSingle_pageChange"
								:total="tan_bjSingle_allData.total" :pageSize="tan_bjSingle_pageSize" :hideOnSinglePage="true"
								show-less-items style="text-align: center;" />
						</div>
					</div>
				</div>
			</a-modal>
		</div>
		<!-- 弹窗_睡眠整体情况列表 -->
		<a-modal :title="'睡眠报告'" :visible="tan_sleepAll_show" :maskClosable="false" @cancel="tan_sleepAll_show = false"
			:dialog-style="{ 'min-width': '900px', 'max-width': '900px' }" :footer="null" id="viewBox">
			<div class="needGZ_TanWrap" v-if="tan_sleepAll_show && sleepCountData">
				<div class="needGZ_Tan">
					<div class="needGZ_Top">
						<div class="time">最近30天</div>
						<div class="time2">&nbsp;/&nbsp;</div>
						<div class="time2">睡眠整体情况</div>
						<div class="chazi" @click="tan_sleepAll_show = false">X</div>
					</div>
					<div class="needGZ_Cont">
						<div class="sleepWrap">
							<div class="sleepTopWrap">
								<div :class="['sleepTopList', tan_sleepAll_type == 1 ? 'sleepTopListSel' : '']"
									@click="cli_tan_sleepAll_type(1)">睡眠得分较低</div>
								<div :class="['sleepTopList', tan_sleepAll_type == 2 ? 'sleepTopListSel' : '']"
									@click="cli_tan_sleepAll_type(2)">睡眠时长异常</div>
								<div :class="['sleepTopList', tan_sleepAll_type == 3 ? 'sleepTopListSel' : '']"
									@click="cli_tan_sleepAll_type(3)">跌到风险偏高</div>
							</div>
							<div class="sTypeWrap" v-if="tan_sleepAll_type == 1">
								<div class="sTypeList sTypeListSel">得分在60分以下：{{ sleepCountData.score0059 }}次</div>
							</div>
							<div class="sTypeWrap" v-if="tan_sleepAll_type == 2">
								<div :class="['sTypeList', tan_sleepAll_subType == 1 ? 'sTypeListSel' : '']"
									@click="cli_tan_sleepAll_subType(1)">6小时以下：{{ sleepCountData.sleepLenValidMin6hDown }}次</div>
								<div :class="['sTypeList', tan_sleepAll_subType == 2 ? 'sTypeListSel' : '']"
									@click="cli_tan_sleepAll_subType(2)">10小时以上：{{ sleepCountData.sleepLenValidMin10hUp }}次</div>
							</div>
							<div class="sTypeWrap" v-if="tan_sleepAll_type == 3">
								<div class="sTypeList sTypeListSel">得分在50分以上：{{ sleepCountData.fallindex50100 }}次</div>
							</div>

							<div v-if="sleepPageListData">
								<table class="bjTable">
									<tr>
										<td :key="index" v-for="(item, index) in sleepPageListTableArr"
											@click="cli_tan_sleepAll_table(item.sortField)">
											<div class="flex_Cen_Cen">
												<div>{{ item.name }}</div>
												<div class="ml5" v-if="item.sortField != 'oper'">
													<img class="tableIcon"
														v-if="tan_sleepAll_sortField == '' || item.sortField != tan_sleepAll_sortField"
														src="../../../assets/tableIcon.png" alt="">
													<img class="tableIcon"
														v-if="item.sortField == tan_sleepAll_sortField && tan_sleepAll_sortOrder == 'ascend'"
														src="../../../assets/tableIcon1.png" alt="">
													<img class="tableIcon"
														v-if="item.sortField == tan_sleepAll_sortField && tan_sleepAll_sortOrder == 'descend'"
														src="../../../assets/tableIcon2.png" alt="">
												</div>
											</div>
										</td>
									</tr>
									<tr :key="index" v-for="(item, index) in sleepPageListData.records">
										<td>{{ item.buAndFlName }}</td>
										<td>{{ item.count }}</td>
										<td @click="clc_tan_sleepAll_see(item.bedId)">
											<div class="color1890ff cursorPointer">查看</div>
										</td>
									</tr>
								</table>
							</div>


							<div class="sleepFenYeWrap" v-if="sleepPageListData">
								<a-pagination v-model="tan_sleepAll_pageNum" @change="tan_sleepAll_pageChange"
									:total="sleepPageListData.total" :pageSize="tan_sleepAll_pageSize" :hideOnSinglePage="true"
									show-less-items style="text-align: center;" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</a-modal>
		<!-- 弹窗_睡眠整体情况查看异常 -->
		<a-modal :title="'睡眠报告'" :visible="tan_sleep_abn_show" :maskClosable="false" @cancel="tan_sleep_abn_show = false"
			:dialog-style="{ 'min-width': '900px', 'max-width': '900px' }" :footer="null" id="viewBox">
			<div class="needGZ_TanWrap" v-if="tan_sleep_abn_show && sleepSituatData">
				<div class="needGZ_Tan bgF3F4F7" style="min-height: auto;">
					<div class="needGZ_Top">
						<div class="time">{{ sleepSituatData.buAndFlName }}</div>
						<div class="time2">&nbsp;|&nbsp;</div>
						<div class="time2" v-if="tan_sleepAll_type == 1">睡眠得分情况</div>
						<div class="time2" v-if="tan_sleepAll_type == 2">睡眠时长情况</div>
						<div class="time2" v-if="tan_sleepAll_type == 3">跌倒风险指数情况</div>
						<div class="chazi" @click="tan_sleep_abn_show = false">X</div>
					</div>
					<div class="needGZ_Cont">
						<div class="sleepAbnWrap">
							<div class="b_comTopCont">
								<div class="dayNum ml20">&nbsp;</div>
								<div class="dayName ml0" v-if="tan_sleepAll_type == 1">睡眠得分中位数：{{ sleepSituatData.median }}分</div>
								<div class="dayName ml0" v-if="tan_sleepAll_type == 2">睡眠时长中位数：{{ sleepSituatData.medianHandle }}</div>
								<div class="dayName ml0" v-if="tan_sleepAll_type == 3">跌倒风险指数中位数：{{ sleepSituatData.median }}</div>
								<div class="daySeeReport" @click="details(sleepSituatData.bedId, sleepSituatData.buAndFlName, '43223')">
									查看完整报告</div>
							</div>
							<div class="referVal">
								<div class="referValRight">
									<div class="gangKuai" v-if="tan_sleepAll_type == 2"></div>
									<div class="gantTip" v-if="tan_sleepAll_type == 2">正常范围</div>
									<div class="gangWrap ml24">
										<div class="gang bg63B2FB"></div>
										<div class="gang bg63B2FB"></div>
										<div class="gang bg63B2FB"></div>
										<div class="gang bg63B2FB"></div>
										<div class="gang bg63B2FB"></div>
									</div>
									<div class="gantTip" style="margin-right: 17px;">中位数</div>
								</div>
							</div>
							<div v-if="tan_sleepAll_type == 1">
								<div id="tan_sleep_abn_score" style="height: 110px;"></div>
							</div>
							<div v-if="tan_sleepAll_type == 2">
								<div id="tan_sleep_abn_time" style="height: 110px;"></div>
							</div>
							<div v-if="tan_sleepAll_type == 3">
								<div id="tan_sleep_abn_fall" style="height: 110px;"></div>
							</div>

						</div>
					</div>
				</div>
			</div>
		</a-modal>
		<!-- 弹窗_关注老人列表_1_7 -->
		<tan_needGz_list_one_seven ref="tan_needGz_list_one_seven"></tan_needGz_list_one_seven>
		<!-- 弹窗_关注老人单人详情 -->
		<tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>


	</div>
</template>

<script>
import tan_needGz_list_one_seven from './tan_needGz_list_one_seven.vue';      //弹窗_关注老人列表_1_7
import tan_needGz_sin from './tan_needGz_sin.vue';      //弹窗_关注老人单人详情
export default {
	components: { tan_needGz_list_one_seven, tan_needGz_sin },
	filters: {
		dataChange(val) {
			let newVal = val.slice(5, 7) + '月' + val.slice(8, 10) + '日'
			return newVal;
		},
		dataChange2(val) {
			let newVal = val
			newVal = newVal.replace('年', '-');
			newVal = newVal.replace('月', '-');
			newVal = newVal.replace('日', '');
			return newVal;
		},
	},
	props: {
		healthBigData: null,
		bjAllData: null,
		// gzOldData: null
	},
	watch: {
		bjAllData(newVal, oldVal) {
			console.log(newVal)
			this.new_bjAllData = newVal

			this.$nextTick((res) => {
				this.dataRender()     //数据渲染
			})
		},
	},
	data() {
		return {
			allSpinning: true,
			activeDates: [],
			myChart_Bar: null,
			myChart_Line: null,
			sleepChartPolice: null,


			// 报警事件部分
			new_bjAllData: null,
			oneData: null,          //报警单日数据
			weekData: null,         //报警七天数据
			moonData: null,         //报警三十天数据
			bj_nowSelWhat: 1,       //报警当前选的什么  1单日 7七天

			// 需关注老人部分
			new_gzOldData: null,
			gzOld_nowSelWhat: 1,      //需关注老人当前选的什么  1单日 7七天
			iswordsRoll: false,    //文字是否滚动


			// 弹窗_报警列表部分
			bjEventAllTan: false,         // 弹窗_报警列表
			AlarmEveCount: null,          //获取报警事件的次数和比例和比例列表数据
			AlarmEveTableArr: [],       //报警事件表格头
			AlarmEvePageList: null,   //报警分页数据
			selectDateType: 1,            // 弹窗报警列表内当前选的什么1，7，30，-1默认1
			selectDateListType: '',        // 弹窗报警列表内当前选哪个类型 1.离床过久2.跌倒3.呼吸过速4.呼吸暂停过久5.心跳过缓6.心跳过速 9.卫生间长时间停留	
			tan_bjList_typeArr: [],       // 弹窗_报警列表_类别数组（离床过久，呼吸过速等）
			tan_bjList_sortField: '',   //排序字段
			tan_bjList_sortOrder: 'ascend',   //顺序规则 正序-ascend，倒序-descend
			pageNum: 1,
			pageSize: 21,

			// 弹窗_报警单人详情
			tan_bjSingle_allData: null,
			tan_bjSingle_show: false,
			tan_bjSingle_selType: 1,    //选的单日还是七天 1 7
			tan_bjSingle_title: '',     //标题  
			tan_bjSingle_bedId: '',     //
			tan_bjSingle_pageNum: 1,
			tan_bjSingle_pageSize: 20,

			// 弹窗_睡眠整体情况列表
			sleepSituation_data: null,          //睡眠整体情况数据
			tan_sleepAll_show: false,
			tan_sleepAll_type: 1,               //睡眠得分1 睡眠时长2 跌倒风险指数3
			tan_sleepAll_subType: 1,            //6小时以下1  10小时以上2
			sleepCountData: null,               //获取详情页睡眠整体情况次数数据
			sleepPageListData: null,            //获取睡眠整体情况分页列表数据
			sleepPageListTableArr: [],          //睡眠整体情况列表表格头
			tan_sleepAll_sortField: '',         //排序字段
			tan_sleepAll_sortOrder: 'ascend',   //顺序规则 正序-ascend，倒序-descend
			tan_sleepAll_type: 1,               //事件类型 睡眠得分1 睡眠时长2 跌到风险指数3
			tan_sleepAll_pageNum: 1,
			tan_sleepAll_pageSize: 20,

			// 弹窗_睡眠整体情况异常
			tan_sleep_abn_show: false,
			tan_sleepAll_bedId: '',
			sleepSituatData: null,              //弹窗_睡眠整体情况查看异常数据


		};
	},
	created() { },
	mounted() {

		this.getActiveDates();
		this.getNeedFollowTable()      //查看需要关注老人首页画图和数据展示


	},
	methods: {
		// 报警事件获取日
		getHomeAlarmDate() {
			this.$get(
				'api/v4/home/getHomeAlarmDate',
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.oneData = res.data          //报警单日数据
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 报警事件获取周
		getHomeAlarmWeekDate() {
			this.$get(
				'api/v4/home/getHomeAlarmWeekDate',
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.weekData = res.data    //报警七天数据

							// 报警比例_七天
							if (this.weekData.moreDayRedioList) {
								let bjblData_week = {
									xAxis: {
										data: this.weekData.moreDayRedioList.dateList
									},
									series: {
										// data: [120,30,23,230,14]
										data: this.weekData.moreDayRedioList.ratioList
									}
								}
								this.$nextTick((res) => {
									this.getMyChart_optionLine('ec_id_bjbl', 'bjbl', bjblData_week);      //报警比例_七天
								})
							}
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},

		// 报警事件获取月
		getHomeAlarmMongthDate() {
			this.$get(
				'api/v4/home/getHomeAlarmMongthDate',
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.moonData = res.data    //报警三十天数据

							// 报警比例_三十天
							if (this.moonData.moreDayRedioList) {
								let bjblData_moon = {
									xAxis: {
										data: this.moonData.moreDayRedioList.dateList
									},
									series: {
										data: this.moonData.moreDayRedioList.ratioList
									}
								}
								this.$nextTick((res) => {
									this.getMyChart_optionLine('ec_id_bjbl3', 'bjbl', bjblData_moon);     //报警比例_三十天
								})
							}



							// 报警事件30天各数据重组
							let moon_lcbj = { xData: '离床报警\n次数', yData: 0 }
							let moon_ddcs = { xData: '跌倒次数', yData: 0 }
							let moon_wsjtl = { xData: '卫生间停留次数', yData: 0 }
							let moon_hxgs = { xData: '呼吸过速', yData: 0 }
							let moon_hxgr = { xData: '呼吸暂停过久', yData: 0 }
							let moon_xdgs = { xData: '心动过速', yData: 0 }
							let moon_xdgh = { xData: '心动过缓', yData: 0 }


							let hTList = this.moonData.homeAlarmEventTypeList
							for (let i = 0; i < hTList.length; i++) {
								if (hTList[i].type == 1) {            //离床过久
									moon_lcbj.yData = hTList[i].count
								} else if (hTList[i].type == 2) {      //跌倒
									moon_ddcs.yData = hTList[i].count
								} else if (hTList[i].type == 4) {      //呼吸过速
									moon_hxgs.yData = hTList[i].count
								} else if (hTList[i].type == 5) {      //呼吸暂停过久
									moon_hxgr.yData = hTList[i].count
								} else if (hTList[i].type == 8) {      //心跳过缓
									moon_xdgh.yData = hTList[i].count
								} else if (hTList[i].type == 7) {      //心跳过速
									moon_xdgs.yData = hTList[i].count
								} else if (hTList[i].type == 9) {      //卫生间长时间停留
									moon_wsjtl.yData = hTList[i].count
								}
							}
							// 离床报警_三十天
							let lcbjData = {
								xAxis: {
									// data: ['离床报警\n次数']
									data: [moon_lcbj.xData]
								},
								series: {
									data: [moon_lcbj.yData]
								}
							}
							// 跌倒停留呼吸心动
							let lcbjData2 = {
								xAxis: {
									// data: ['跌倒次数','卫生间停留\n过久次数','呼吸过速','呼吸暂停过久','心动过速','心动过缓']
									data: []
								},
								series: {
									data: []
								}
							}

							// 报警事件30天柱状图逻辑  deviceClass 0都有 1睡眠 2跌倒
							if (this.moonData.deviceClass == 0) {       //都有
								lcbjData2.xAxis.data = ['跌倒次数', '卫生间停留\n过久次数', '呼吸过速', '呼吸暂停\n过久', '心动过速', '心动过缓']
								lcbjData2.series.data = [moon_ddcs.yData, moon_wsjtl.yData, moon_hxgs.yData, moon_hxgr.yData, moon_xdgs.yData, moon_xdgh.yData]

								this.$nextTick((res) => {
									this.getMyChart_optionBar('ec_id_lcbj', 'lcbj', lcbjData);      //离床报警
									this.getMyChart_optionBar('ec_id_lcbj2', 'lcbj2', lcbjData2);   //跌倒停留呼吸心动
								})
							} else if (this.moonData.deviceClass == 2) {     //睡眠（没有跌倒和卫生间停留）
								lcbjData2.xAxis.data = ['呼吸过速', '呼吸暂停过久', '心动过速', '心动过缓']
								lcbjData2.series.data = [moon_hxgs.yData, moon_hxgr.yData, moon_xdgs.yData, moon_xdgh.yData]

								this.$nextTick((res) => {
									this.getMyChart_optionBar('ec_id_lcbj', 'lcbj', lcbjData);      //离床报警
									this.getMyChart_optionBar('ec_id_lcbj2', 'lcbj2', lcbjData2);   //跌倒停留呼吸心动
								})
							} else if (this.moonData.deviceClass == 1) {     //跌倒（只显示跌倒和卫生间停留）
								lcbjData2.xAxis.data = ['跌倒次数', '卫生间停留\n过久次数']
								lcbjData2.series.data = [moon_ddcs.yData, moon_wsjtl.yData]

								this.$nextTick((res) => {
									this.getMyChart_optionBar('ec_id_lcbj2', 'lcbj2', lcbjData2);   //跌倒停留呼吸心动
								})

							}
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 获取睡眠整体情况
		getSleepSituation() {
			this.$get(
				'api/v4/home/getSleepSituation',
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.sleepSituation_data = res.data
							let sst = res.data
							// 睡眠得分
							// let sst = this.new_bjAllData.sleepSituation
							let smdfData = {
								xAxis: {
									data: ['0~59', '60~84', '85以上']
								},
								series: {
									data: [sst.score0059, sst.score6084, sst.score85100]
								}
							}
							// 睡眠时长
							let smscData = {
								xAxis: {
									data: ['6h以下', '6~10h', '10h以上']
								},
								series: {
									data: [sst.sleepLenValidMin6hDown, sst.sleepLenValidMin6hAnd10h, sst.sleepLenValidMin10hUp]
								}
							}
							// 跌到风险指数
							let ddfxzsData = {
								xAxis: {
									data: ['50及以下', '50以上']
								},
								series: {
									data: [sst.fallindex0050, sst.fallindex50100]
								}
							}

							this.$nextTick((res) => {
								this.getMyChart_optionBar('ec_id_smdf', 'smdf', smdfData);            //睡眠得分
								this.getMyChart_optionBar('ec_id_smsc', 'smsc', smscData);            //睡眠时长
								this.getMyChart_optionBar('ec_id_ddfxzs', 'ddfxzs', ddfxzsData);      //跌到风险指数
							})
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		getActiveDates() {
			var day = new Date();
			var time = day.getTime();
			for (var i = 0; i <= 29; i++) {
				var ms = 24 * 3600 * 1000 * i;
				day.setTime(parseInt(time - ms));
				var y = day.getFullYear().toString();
				var m = (day.getMonth() + 1).toString();
				if (m.length <= 1) m = '0' + m;
				var d = day.getDate().toString();
				if (d.length <= 1) d = '0' + d;
				this.activeDates[i] = y + '-' + m + '-' + d;
			}
			//console.log(this.activeDates);
		},
		// 数据渲染
		dataRender() {
			this.getHomeAlarmDate();        // 报警事件获取日
			this.getHomeAlarmWeekDate();    // 报警事件获取周
			this.getHomeAlarmMongthDate();  // 报警事件获取月
			this.getSleepSituation();       // 获取睡眠整体情况

		},
		// 点击报警事件单人出报警单人详情弹窗
		open_bjSingleTan(item) {
			if (this.bjEventAllTan) {         //如果报警列表弹窗是显示状态，取报警列表的type值
				this.tan_bjSingle_selType = this.selectDateType
			} else {            //报警列表弹窗是隐藏状态，取首页的值
				this.tan_bjSingle_selType = this.bj_nowSelWhat;
			}
			// this.tan_bjSingle_selType = 
			console.log(item)
			this.tan_bjSingle_bedId = item.bedId;
			this.tan_bjSingle_title = item.buAndFlName;
			this.tan_bjSingle_show = true;
			this.getAlarmEventInfoList();     //查询报警事件详情
		},
		// 查询报警事件详情
		getAlarmEventInfoList() {
			let obj = {
				alarmType: this.tan_bjList_typeArr.toString(),      //报警事件类型1.离床过久2.跌倒3.呼吸过速4.呼吸暂停过久5.心跳过缓6.心跳过速 9.卫生间长时间停留
				bedId: this.tan_bjSingle_bedId,      //报警事件类型1.离床过久2.跌倒3.呼吸过速4.呼吸暂停过久5.心跳过缓6.心跳过速 9.卫生间长时间停留
				pageNum: this.tan_bjSingle_pageNum,                  //
				pageSize: this.tan_bjSingle_pageSize,
				selectDateType: this.tan_bjSingle_selType,    //取值:1, 7, 30, -1(全部), 该参数不传默认为: 1	
				sortField: this.tan_bjList_sortField,        //排序字段
				sortOrder: this.tan_bjList_sortOrder,    //顺序规则 正序-ascend，倒序-descend
			}
			this.$get(
				'api/v4/home/getAlarmEventInfoList',
				obj,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.tan_bjSingle_allData = res.data
							// console.log(res.data.records[0])

							// this.tan_bjSingle_allData.records = [
							//   {
							//     date: '03-06',
							//     dateCn: "2023年05月06日",
							//     endTime: "17:37:48",
							//     eventName: "测试差联调啦",
							//     startTime: "17:08:05",
							//     time: "17:08-17:37",
							//     type: 2
							//   }
							// ]
							this.$forceUpdate()
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 点击报警事件中的查看全部 出全部弹窗
		cli_bjEveAll(type) {
			this.bjEventAllTan = true;
			if (type) {
				this.selectDateType = 30
			} else {
				this.selectDateType = this.bj_nowSelWhat
			}
			this.getAlarmEventTypeCountList()     //获取报警事件的次数和比例和比例列表
		},
		// 弹窗_报警列表_点击当日或七天
		clc_bjEventAllTan_type(type) {
			this.pageNum = 1;
			this.pageSize = 21;
			this.tan_bjList_sortField = ''
			this.tan_bjList_sortOrder = 'ascend'

			this.selectDateType = type;
			this.getAlarmEventTypeCountList()     //获取报警事件的次数和比例和比例列表
		},
		// 弹窗_报警列表_点击某个类别（离床过久，呼吸过速等）
		clc_topList(index, type) {
			this.pageNum = 1;
			this.pageSize = 21;
			this.tan_bjList_sortField = ''
			this.tan_bjList_sortOrder = 'ascend'

			this.AlarmEveCount.homeAlarmEventTypeList[index].isSelect = !this.AlarmEveCount.homeAlarmEventTypeList[index].isSelect
			let isIndexOf = this.tan_bjList_typeArr.indexOf(type)
			if (isIndexOf != -1) {
				this.tan_bjList_typeArr.splice(isIndexOf, 1)
			} else {
				this.tan_bjList_typeArr.push(type)
			}
			console.log(this.tan_bjList_typeArr)
			if (this.selectDateType == 7) {           //七天
				this.pageSize = 21;
			} else if (this.selectDateType == 30) {    //三十天
				this.pageSize = 14;
			}
			this.getAlarmEventPageList();         //首页报警事件分页接口

		},
		// 弹窗_报警列表_分页
		pageChange(e) {
			console.log(e);
			this.pageNum = e;
			this.getAlarmEventPageList()
		},
		// 获取报警事件的次数和比例和比例列表
		getAlarmEventTypeCountList() {
			this.$get(
				'api/v4/home/getAlarmEventTypeCountList',
				{
					selectDateType: this.selectDateType,      //弹窗报警列表内当前选的什么1，7，30，-1默认1
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.AlarmEveCount = res.data
							this.tan_bjList_typeArr = []    //弹窗_报警列表_类别数组（离床过久，呼吸过速等）
							for (let i = 0; i < this.AlarmEveCount.homeAlarmEventTypeList.length; i++) {
								this.AlarmEveCount.homeAlarmEventTypeList[i].isSelect = true;
								this.tan_bjList_typeArr.push(this.AlarmEveCount.homeAlarmEventTypeList[i].type)
							}

							if (this.selectDateType == 7) {     //如果是周
								this.pageSize = 21
								// for(let i = 0;i < this.AlarmEveCount.moreDayRedioList.ratioList.length;i++){
								//   this.AlarmEveCount.moreDayRedioList.ratioList[i] = this.AlarmEveCount.moreDayRedioList.ratioList[i] * 100
								// }
								console.log('周周周周')
								let seven_bjblData = {
									xAxis: {
										data: this.AlarmEveCount.moreDayRedioList.dateList,
									},
									series: {
										data: this.AlarmEveCount.moreDayRedioList.ratioList
									}
								};
								this.$nextTick((res => {
									this.getMyChart_optionLine('tan_list_ec_Seven_pocThing', 'seven_bjbl', seven_bjblData);
								}))
							}
							if (this.selectDateType == 30) {    //如果是30天
								this.pageSize = 14
								console.log('三十天', this.AlarmEveCount.deviceClass)
								this.tan_bjList_table_handleData();     //弹窗_报警列表_表格头部数据分类
							}



							this.getAlarmEventPageList()
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 首页报警事件分页接口
		getAlarmEventPageList() {
			console.log(this.tan_bjList_typeArr)
			let obj = {
				alarmType: this.tan_bjList_typeArr.toString(),      //报警事件类型1.离床过久2.跌倒3.呼吸过速4.呼吸暂停过久5.心跳过缓6.心跳过速 9.卫生间长时间停留
				pageNum: this.pageNum,                  //
				pageSize: this.pageSize,
				selectDateType: this.selectDateType,    //取值:1, 7, 30, -1(全部), 该参数不传默认为: 1	
				sortField: this.tan_bjList_sortField,        //排序字段
				sortOrder: this.tan_bjList_sortOrder,    //顺序规则 正序-ascend，倒序-descend
			}
			this.$get(
				'api/v4/home/getAlarmEventPageList',
				obj,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.AlarmEvePageList = res.data
							console.log(this.AlarmEvePageList)
							this.$forceUpdate()
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 弹窗_报警列表_表格头部数据分类
		tan_bjList_table_handleData() {
			//deviceClass 0全都有 1只有睡眠 2只有跌倒
			if (this.AlarmEveCount.deviceClass == 0) {
				// this.AlarmEveTableArr = ['床位','呼吸暂停过久','呼吸过速','心动过缓','心动过速','离床过久','跌倒','卫生间停留过久']
				this.AlarmEveTableArr = [
					{
						name: '床位',
						sortField: 'buAndFlName'
					},
					{
						name: '呼吸暂停过久',
						sortField: 'breathSlowCount'
					},
					{
						name: '呼吸过速',
						sortField: 'breathFastCount'
					},
					{
						name: '心动过缓',
						sortField: 'heartSlowCount'
					},
					{
						name: '心动过速',
						sortField: 'heartFastCount'
					},
					{
						name: '离床过久',
						sortField: 'outBedLongTimeCount'
					},
					{
						name: '跌倒',
						sortField: 'fallCount'
					},
					{
						name: '卫生间停留过久',
						sortField: 'fallLongCount'
					}
				]
			} else if (this.AlarmEveCount.deviceClass == 1) {
				this.AlarmEveTableArr = [
					{
						name: '床位',
						sortField: 'buAndFlName'
					},
					{
						name: '呼吸暂停过久',
						sortField: 'breathSlowCount'
					},
					{
						name: '呼吸过速',
						sortField: 'breathFastCount'
					},
					{
						name: '心动过缓',
						sortField: 'heartSlowCount'
					},
					{
						name: '心动过速',
						sortField: 'heartFastCount'
					},
					{
						name: '离床过久',
						sortField: 'outBedLongTimeCount'
					}
				]
			} else if (this.AlarmEveCount.deviceClass == 2) {
				this.AlarmEveTableArr = [
					{
						name: '床位',
						sortField: 'buAndFlName'
					},
					{
						name: '离床过久',
						sortField: 'outBedLongTimeCount'
					},
					{
						name: '跌倒',
						sortField: 'fallCount'
					},
					{
						name: '卫生间停留过久',
						sortField: 'fallLongCount'
					}
				]
			}
			console.log(this.AlarmEveTableArr)
		},
		// 弹窗_报警列表_点击表格头部排序
		cli_tan_bjList_table(sortField) {
			if (this.tan_bjList_sortField == sortField) {     //如果当期点击的本身就是原来排序的字段，那只需修改排序规则即可
				this.tan_bjList_sortOrder = this.tan_bjList_sortOrder == 'ascend' ? 'descend' : 'ascend'
			} else {        //如果选的排序字段不是原来排序的字段
				this.tan_bjList_sortField = sortField;
				this.tan_bjList_sortOrder = 'ascend'
			}
			this.pageNum = 1;
			this.getAlarmEventPageList()
		},



		// 弹窗_报警单人详情_点击当日或七天
		clc_bjSingleTan_type(type) {
			this.tan_bjSingle_selType = type;
			this.getAlarmEventInfoList()
		},
		// 弹窗_报警单人详情_分页
		tan_bjSingle_pageChange(e) {
			console.log(e);
			this.pageNum = e;
			this.getAlarmEventInfoList()
		},








		// 查看需要关注老人首页画图和数据展示
		getNeedFollowTable() {
			this.allSpinning = true;
			this.$get(
				'api/v4/home/getNeedFollowTable',
				{
					selectDateType: this.gzOld_nowSelWhat
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.new_gzOldData = res.data
							// 假数据
							// let falseData = {
							//   'bedId': 23,
							//   'buAndFlName': '副书记啊迪卢克放暑假了开发机打撒',
							// }
							// for(let i = 0;i < 4;i++){
							//   this.new_gzOldData.needFollowPageListVoList.push(falseData)
							// }
							// this.new_gzOldData.resultFlag = true;
							// 假数据end
							console.log(this.new_gzOldData)

							if (this.gzOld_nowSelWhat == 7 && this.new_gzOldData.resultFlag) {
								// 需要关注老人_七天
								let needFollow = {
									xAxis: {
										data: this.new_gzOldData.moreDayRedioList.dateList
									},
									series: {
										data: this.new_gzOldData.moreDayRedioList.ratioList
										// data: this.weekData.moreDayRedioList
									}
								}
								setTimeout(() => {
									this.getMyChart_optionLine('ec_id_bjbl2', 'bjbl', needFollow);        //需关注老人_七天
								}, 0);

							}
							this.$forceUpdate();
						}
						this.allSpinning = false;


						this.$nextTick(() => {
							let element = document.getElementById("xgzHover");
							console.log(element)
							element.addEventListener("mouseover", () => {
								console.log("鼠标悬浮在元素上");
								this.iswordsRoll = true;
							});
							element.addEventListener("mouseout", () => {
								console.log("鼠标离开元素");
								this.iswordsRoll = false;
							});
						})
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 首页_需关注老人_点击当日或七天
		cli_gzOld_nowSelWhat(type) {
			this.gzOld_nowSelWhat = type;
			this.getNeedFollowTable()
		},

		// 点击关注老人中的查看全部 出全部弹窗 
		cli_gzListAll(type) {
			let data = { type: type }
			this.$refs.tan_needGz_list_one_seven.openComponent_tan_needGz_list_one_seven(data)
		},
		// 点击关注老人中的某一个，出需关注单人详情
		open_tan_needGZ_single(data) {
			let newData = data
			newData.nowType = this.gzOld_nowSelWhat
			this.$refs.tan_needGz_sin.openComponent(newData)
		},







		// 弹窗_睡眠整体情况部分
		// 点击睡眠整体情况查看异常
		seeSleepTan() {
			this.tan_sleepAll_show = true;
			this.getSleepSituationCount()
		},
		// 弹窗_睡眠情况列表_点击某个类别（睡眠得分，睡眠时长，跌到风险）
		cli_tan_sleepAll_type(type) {
			this.tan_sleepAll_type = type
			this.tan_sleepAll_pageNum = 1
			if (type == 2) {
				this.tan_sleepAll_subType = 1   //六小时以下1 十小时以上2
			}
			this.selectSleepSituationPageList();
		},
		// 弹窗_睡眠情况列表_睡眠时长_点击某个类别（六小时以下1，十小时以上2）
		cli_tan_sleepAll_subType(type) {
			this.tan_sleepAll_subType = type;
			this.tan_sleepAll_pageNum = 1;
			this.selectSleepSituationPageList();
		},
		// 弹窗_睡眠情况列表_分页
		tan_sleepAll_pageChange(e) {
			console.log(e);
			this.tan_sleepAll_pageNum = e;
			this.selectSleepSituationPageList()
		},
		// 获取详情页睡眠整体情况次数
		getSleepSituationCount() {
			let obj = {
			}
			this.$get(
				'api/v4/home/getSleepSituationCount',
				obj,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.sleepCountData = res.data;
							if (this.tan_sleepAll_type == 1) {          //睡眠得分
								// 60分以下
								this.sleepPageListTableArr = [
									{
										name: '床位',
										sortField: 'buAndFlName'
									},
									{
										name: '次数',
										sortField: 'count'
									},
									{
										name: '操作',
										sortField: 'oper'
									}
								]
							} else if (this.tan_sleepAll_type == 2) {        //睡眠时长
								if (this.tan_sleepAll_subType == 1) {         //6小时以下
									this.sleepPageListTableArr = [
										{
											name: '床位',
											sortField: 'buAndFlName'
										},
										{
											name: '次数',
											sortField: 'count'
										},
										{
											name: '操作',
											sortField: 'oper'
										}
									]
								} else if (this.tan_sleepAll_subType == 2) {   //10小时以上
									this.sleepPageListTableArr = [
										{
											name: '床位',
											sortField: 'buAndFlName'
										},
										{
											name: '次数',
											sortField: 'count'
										},
										{
											name: '操作',
											sortField: 'oper'
										}
									]
								}

							} else if (this.tan_sleepAll_type == 3) {    //跌倒风险指数
								// 50分以上
								this.sleepPageListTableArr = [
									{
										name: '床位',
										sortField: 'buAndFlName'
									},
									{
										name: '次数',
										sortField: 'fallindex50100'
									},
									{
										name: '操作',
										sortField: 'oper'
									}
								]
							}
							this.selectSleepSituationPageList();
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);

		},
		// 获取睡眠整体情况分页列表
		selectSleepSituationPageList() {
			let obj = {
				pageNum: this.tan_sleepAll_pageNum,                  //
				pageSize: this.tan_sleepAll_pageSize,
				selectDateType: 30,                         //取值:1, 7, 30, -1(全部), 该参数不传默认为: 1	
				sortField: this.tan_sleepAll_sortField,      //排序字段  
				sortOrder: this.tan_sleepAll_sortOrder,     //顺序规则 正序-ascend，倒序-descend
				subType: this.tan_sleepAll_subType,         //六小时以下1 十小时以上2
				type: this.tan_sleepAll_type,               //事件类型 睡眠得分1 睡眠时长2 跌到风险指数3
			}
			this.$get(
				'api/v4/home/selectSleepSituationPageList',
				obj,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.sleepPageListData = res.data;
							// for(let i = 0;i < 15;i++){
							//   this.sleepPageListData.records.push(res.data.records[0])
							// }

							this.$forceUpdate()
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 弹窗_睡眠整体情况_点击表格头部排序
		cli_tan_sleepAll_table(sortField) {
			if (sortField == 'oper') {
				return;
			}

			if (this.tan_sleepAll_sortField == sortField) {     //如果当期点击的本身就是原来排序的字段，那只需修改排序规则即可
				this.tan_sleepAll_sortOrder = this.tan_sleepAll_sortOrder == 'ascend' ? 'descend' : 'ascend'
			} else {        //如果选的排序字段不是原来排序的字段
				this.tan_sleepAll_sortField = sortField;
				this.tan_sleepAll_sortOrder = 'ascend'
			}
			this.tan_sleepAll_pageNum = 1;
			this.selectSleepSituationPageList()
		},
		// 弹窗_睡眠整体情况_点击表格内查看
		clc_tan_sleepAll_see(bedId) {
			this.tan_sleep_abn_show = true;
			this.tan_sleepAll_bedId = bedId;
			this.getSleepSituationByBedId();
		},
		// 弹窗_睡眠整体情况查看异常
		getSleepSituationByBedId() {
			let obj = {
				bedId: this.tan_sleepAll_bedId,     //床位id
				type: this.tan_sleepAll_type,       //事件类型 睡眠得分1 睡眠时长2 跌倒风险指数3
			}
			this.$get(
				'api/v4/home/getSleepSituationByBedId',
				obj,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.sleepSituatData = res.data;

							if (this.sleepSituatData.median < 60) {
								this.sleepSituatData.medianHandle = this.sleepSituatData.median + '分钟'
							} else {
								let hh, mm;
								hh = parseInt(this.sleepSituatData.median / 60)
								mm = this.sleepSituatData.median % 60
								this.sleepSituatData.medianHandle = hh + '小时' + mm + '分钟'
							}

							let data = {
								xAxis: {
									data: res.data.reportTrendsDataVo.xaxis,
								},
								series: {
									data: res.data.reportTrendsDataVo.data
								},
								avg: res.data.median
							};

							// 睡眠时长
							let sleepDurationChart = {};
							sleepDurationChart.activeType = 30;
							sleepDurationChart.com_xAxis = res.data.reportTrendsDataVo.xaxis;
							sleepDurationChart.reportTrendsDataVo = res.data.reportTrendsDataVo;
							sleepDurationChart.avg = res.data.median

							this.$nextTick((res => {
								if (this.tan_sleepAll_type == 1) {
									this.getMyChart_optionLine('tan_sleep_abn_score', 'tan_smAbn', data);
								} else if (this.tan_sleepAll_type == 2) {
									this.getMyChart6('tan_sleep_abn_time', sleepDurationChart); // 睡眠时长 
								} else if (this.tan_sleepAll_type == 3) {
									this.getMyChart_optionLine('tan_sleep_abn_fall', 'tan_smAbn', data);
								}

							}))
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					this.$message.error('服务端发生异常');
				}
			);
		},
		// 弹窗_睡眠整体情况查看异常_查看完整报告
		details(bedId, bedName, sn) {
			var scope = {
				bedId: bedId,
				bedName: bedName,
				activeType: 4,
				activeDate: this.activeDates[0],
				sn: sn,
			};
			this.$parent.details(scope);
		},

		// 公共柱状图
		getMyChart_optionBar(idName, type, olddata) {
			let data = olddata
			// type  离床报警lcbj   跌倒，停留，呼吸，心动lcbj2  睡眠得分smdf  睡眠时长smsc 跌倒风险指数ddfxzs
			this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
			console.log(idName, type, data)

			let maxNum = Math.max(...data.series.data)
			let yAxis_max = Math.round(maxNum / 10) * 10 + 10

			let grid_left = '0.5%'
			let series_itemStyle_color = ['#1890FF', '#1890FF']
			if (type == 'lcbj') {             //离床报警

			} else if (type == 'lcbj2') {     //跌倒，停留，呼吸，心动

			} else if (type == 'smdf') {      //睡眠得分
				// 需要这种单独加柱状颜色
				// data: [
				//   120,
				//   {
				//     value: 140,
				//     itemStyle: {
				//       color: '#a90000'
				//     }
				//   },
				//   150,
				// ],
				// 需要这种单独加柱状颜色end
				data.series.data[0] = {
					value: data.series.data[0],
					itemStyle: {
						color: '#FF7186'
					}
				}
			} else if (type == 'smsc') {      //睡眠时长
				data.series.data[0] = {
					value: data.series.data[0],
					itemStyle: {
						color: '#FF7186'
					}
				}
				data.series.data[2] = {
					value: data.series.data[2],
					itemStyle: {
						color: '#FF7186'
					}
				}
			} else if (type == 'ddfxzs') {      //跌到风险指数
				data.series.data[1] = {
					value: data.series.data[1],
					itemStyle: {
						color: '#FF7186'
					}
				}
			}
			var optionBar = {
				tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 1)',
					borderColor: 'rgba(24, 144, 255, 0.6)',
					borderWidth: 1,
					spanStyle: {
						color: '#fff',
					},
					confine: true,
					borderRadius: 5,
					formatter: function (params) {
						console.log(type);
						console.log(params);
						if (type == 'lcbj') {         //离床报警
							return (
								'离床报警次数' +
								'<br/>' +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
								params[0].data + '次'
							);
						} else if (type == 'lcbj2' || type == 'smdf' || type == 'smsc' || type == 'ddfxzs') {      //离床报警2  睡眠得分 睡眠时长 跌到风险指数
							if (params[0].name == '卫生间停留\n过久次数') {
								return (
									'卫生间停留过久次数' +
									'<br/>' +
									'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
									params[0].data + '次'
								);
							} else if (params[0].name == '呼吸暂停\n过久') {
								return (
									'呼吸暂停过久' +
									'<br/>' +
									'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
									params[0].data + '次'
								);
							} else if (params[0].name == '跌倒次数' || params[0].name == '呼吸过速' || params[0].name == '心动过速' || params[0].name == '心动过缓') {
								return (
									params[0].name +
									'<br/>' +
									'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
									params[0].data + '次'
								);
							} else if (params[0].name == '0~59' || params[0].name == '6h以下' || params[0].name == '10h以上' || params[0].name == '50以上') {
								return (
									params[0].name +
									'<br/>' +
									'<span style="background:#FF7186;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
									params[0].data.value + '次'
								);
							} else if (params[0].name == '60~84' || params[0].name == '85以上' || params[0].name == '6~10h' || params[0].name == '50及以下') {
								return (
									params[0].name +
									'<br/>' +
									'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
									params[0].data + '次'
								);
							} else {
								return (
									params[0].name +
									'<br/>' +
									'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
									params[0].data + '次'
								);
							}
						} else if (type == '') {
							return (
								params[0].name +
								'<br/>' +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>紊乱指数' +
								(params[0].data.isEmpty ? '-' : params[0].data.value)
							);
						}
					},
				},
				grid: {
					left: grid_left,
					// left: '0%',
					right: '0.5%',
					top: '15%',
					bottom: '1%',
					containLabel: true,
				},
				xAxis: [
					{
						type: 'category',
						data: data.xAxis.data,
						axisLabel: {
							interval: 0,
							// spanStyle: {
							//   color: '', //坐标的字体颜色
							// },
							textStyle: {
								color: '#5E6779',
								fontSize: '10',
								itemSize: '',
							}

						},
						axisLine: {
							lineStyle: {
								color: '#9094A6',
							},
						},

						axisTick: {
							show: false,
							// alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						max: yAxis_max,
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#CACDD9'
							}
						},
						minInterval: 1100, //设置最小间隔为1，防止出现小数
						axisLabel: {
							// spanStyle: {
							//   color: '#5E6779', //坐标的字体颜色
							// },
							textStyle: {
								color: '#5E6779',
								fontSize: '10',
								itemSize: ''
							}
						},
						axisLine: {
							lineStyle: {
								color: '#c7c6c9',
							},
							show: false,
						},
						splitNumber: 1,
					},
				],
				series: [
					{
						data: data.series.data,
						type: 'bar',
						barWidth: 20,
						itemStyle: {
							normal: {
								barBorderRadius: [5, 5, 0, 0],   //圆角
								color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [{
									// 四个数字分别对应 数组中颜色的开始位置，分别为 右，下，左，上。例如（1,0,0,0 ）代表从右边开始渐
									// 变。offset取值为0~1，0代表开始时的颜色，1代表结束时的颜色，柱子表现为这两种颜色的渐变。
									offset: 0,
									color: series_itemStyle_color[0]
								}, {
									offset: 1,
									color: series_itemStyle_color[1]
								}]),
							}
						}
					}

				]
			}
			this.myChart_Bar.setOption(optionBar, true);
			window.addEventListener('resize', () => {
				this.myChart_Bar.resize();
			});
			this.$forceUpdate()
		},
		// 公共折线图
		getMyChart_optionLine(idName, type, olddata) {
			let data = olddata
			// type  报警比例bjbl   弹窗_报警列表_报警比例_七天seven_bjbl   弹窗_睡眠整体情况查看异常tan_smAbn
			this.myChart_Line = this.$echarts.init(document.getElementById(idName));
			console.log(idName, type, data)

			let maxNum = Math.max(...data.series.data)
			let yAxis_max = Math.round(maxNum / 10) * 10 + 10


			let series_itemStyle_color = ['#1890FF', '#1890FF']


			let grid_left = '0.5%'
			let grid_bottom = '1%'

			if (type == 'bjbl') {             //报警比例
				yAxis_max = null
				// data.xAxis.data = []
				grid_bottom = '4%'
			} else if (type == 'seven_bjbl') {
				yAxis_max = null
			} else if (type == 'tan_smAbn') {
				yAxis_max = null
			}
			var optionLine = {
				tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 1)',
					borderColor: 'rgba(24, 144, 255, 0.6)',
					borderWidth: 1,
					spanStyle: {
						color: '#fff',
					},
					confine: true,
					borderRadius: 5,
					formatter: function (params) {
						console.log(type);
						console.log(params);
						if (type == 'bjbl') {      //报警比例
							return (
								// params[0].name +
								// '<br/>' +
								// '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
								// params[0].data + '%'


								params[0].name +
								'<br/>' +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
								params[0].data + '%'
							);
						} else if (type == 'seven_bjbl') {
							return (
								params[0].name +
								'<br/>' +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
								params[0].data + '%'
							);
						} else if (type == 'tan_smAbn') {
							return (
								params[0].name +
								'<br/>' +
								'<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
								params[0].data
							);

						}
					},
				},
				grid: {
					left: grid_left,
					// left: '0%',
					right: '0.5%',
					top: '15%',
					bottom: grid_bottom,
					containLabel: true,
				},
				xAxis: [
					{
						type: 'category',
						data: data.xAxis.data,
						axisLabel: {
							// interval: 10,
							// spanStyle: {
							//   color: '', //坐标的字体颜色
							// },
							textStyle: {
								color: '#5E6779',
								fontSize: '10',
								itemSize: '',
							},
							show: type == 'bjbl' ? false : true
						},
						axisLine: {
							lineStyle: {
								color: '#9094A6',
							},
						},

						axisTick: {
							show: false,
							// alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						max: yAxis_max,
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#CACDD9'
							}
						},
						// minInterval: 1100, //设置最小间隔为1，防止出现小数
						minInterval: 1, //设置最小间隔为1，防止出现小数
						axisLabel: {
							// spanStyle: {
							//   color: '#5E6779', //坐标的字体颜色
							// },
							textStyle: {
								color: '#5E6779',
								fontSize: '10',
								itemSize: ''
							}
						},
						axisLine: {
							lineStyle: {
								color: '#c7c6c9',
							},
							show: false,
						},
						splitNumber: 1,
					},
				],
				series: [
					{
						data: data.series.data,
						type: 'line',
						barWidth: 20,
						// symbol: 'none',
						lineStyle: {           //线条颜色
							color: '#1890FF'
						},
						// smooth: true,         //平滑处理
						symbol: 'circle',
						showSymbol: type == 'bjbl' ? false : true,
						symbolSize: 8,
						color: '#1890FF',
						areaStyle: type == 'seven_bjbl' || type == 'tan_smAbn' ? {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color: 'rgba(24, 144, 255, 0.4)', // 0% 处的颜色
									},
									{
										offset: 1,
										color: 'rgba(24, 144, 255, 0.05)', // 100% 处的颜色
									},
								],
								global: false, // 缺省为 false
							},
						} : null,
						markLine: type == 'tan_smAbn' ? {
							symbol: 'none',
							emphasis: {
								lineStyle: {
									width: 1, // hover时的折线宽度
								},
							},
							data: [
								{
									silent: false, //鼠标悬停事件  true没有，false有
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: 'dashed',
										color: '#63B2FB',
									},
									label: {
										position: 'end',
										formatter: '',
									},
									yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
								},
							],
						} : null,
					}

				]
			}
			this.myChart_Line.setOption(optionLine, true);
			window.addEventListener('resize', () => {
				this.myChart_Line.resize();
			});
			this.$forceUpdate()
		},

		// 睡眠平均时长图表
		getMyChart6(idName, data) {
			this.myChart6 = this.$echarts.init(document.getElementById(idName));
			console.log(data);
			let hh = data.indexValHour > 0 ? data.indexValHour * 60 : 0;
			let mm = data.indexValMinute > 0 ? data.indexValMinute : 0;
			let sleepAvg = ((data.avg) / 60).toFixed(1); //平均值
			// let sleepAvg = data.avg; //平均值

			// 模拟后端返回数据
			// let qs = ["300", "272", "264", "285", "-", "-", "-"]    //浅睡
			// let ss = ["60", "233", "314", "211", "-", "-", "-"]    //深睡
			// let ss2 = ["60", "20", "264", "300", "-", "-", "-"]    //睡眠
			let qs = data.reportTrendsDataVo.lightData; //浅睡
			let ss = data.reportTrendsDataVo.deepData; //深睡
			let ss2 = data.reportTrendsDataVo.data; //睡眠
			let comLen = qs.length; //公共长度

			let lightSleepList = []; // 浅睡新数据
			let deepSleepList = []; // 深睡新数据

			for (let i = 0; i < comLen; i++) {
				if (qs[i] == '-') {
					lightSleepList.push({
						value: 0,
						timeFonts: 0,
						timeFonts2: 0,
					});
					deepSleepList.push({
						value: 0,
						timeFonts: 0,
						timeFonts2: 0,
					});
				} else {
					lightSleepList.push({
						value: qs[i] / 60,
						timeFonts: this.formaTime(qs[i]),
						timeFonts2: this.formaTime(ss2[i]),
					});
					deepSleepList.push({
						value: ss[i] / 60,
						timeFonts: this.formaTime(ss[i]),
						timeFonts2: this.formaTime(ss2[i]),
					});
				}
			}

			// console.log(deepSleepList)
			// console.log(lightSleepList)
			// console.log(sleepAvg)
			var optionSleepDuration = {
				color: ['#1890FF', '#c394fe', '#f8b4e7', '#f8b5b5'],
				tooltip: {
					confine: true,
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 1)',
					borderColor: 'rgba(24, 144, 255, 0.6)',
					borderWidth: 1,
					spanStyle: {
						color: '#fff',
					},
					formatter: function (params) {
						console.log(params);
						for (var x = 0; x < params.length; i++) {
							if (params[x].data.timeFonts2 == '0') {
								return (
									params[x].name + '<br/>睡眠时长：-<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>深睡时长：-<br/><span style="background:#c394fe;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>浅睡时长：-'
								);
							} else {
								return (
									params[x].name +
									'<br/>睡眠时长：' +
									params[x].data.timeFonts2 +
									'<br/><span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>深睡时长：' +
									params[0].data.timeFonts +
									'<br/><span style="background:#c394fe;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>浅睡时长：' +
									params[1].data.timeFonts
								);
							}
						}
					},
				},
				grid: {
					left: '1%',
					right: '1%',
					top: '15%',
					bottom: '1%',
					containLabel: true,
				},
				xAxis: [
					{
						type: 'category',
						data: data.com_xAxis,
						axisLabel: {
							spanStyle: {
								color: '#c7c6c9', //坐标的字体颜色
							},
							// formatter: function (params) {
							//   return params.replace("-", "<br/>");
							// },
						},
						axisLine: {
							lineStyle: {
								color: '#c7c6c9',
							},
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						type: 'value',
						min: 0,
						// max: 12,
						logBase: 10,
						splitLine: {
							show: true,
						},
						axisLine: {
							lineStyle: {
								color: '#c7c6c9',
							},
							show: false, //显示y轴，新版本默认没显示
						},
						axisLabel: {
							formatter: '{value}h',
							spanStyle: {
								color: '#c7c6c9', //坐标的字体颜色
							},
						},
						splitNumber: 3,
					},
				],
				series: [
					{
						name: '深睡',
						type: 'bar',
						stack: '1',
						barWidth: data.activeType == 2 ? '20' : '10',
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: deepSleepList,
					},

					{
						name: '浅睡',
						type: 'bar',
						stack: '1',
						barWidth: data.activeType == 2 ? '20' : '10',
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: lightSleepList,
						itemStyle: {
							normal: {
								//柱形图圆角，初始化效果
								barBorderRadius: [4, 4, 0, 0],
							},
						},
					},
					{
						name: '总计',
						type: 'line', // 平均值
						data: [sleepAvg],
						// color: "#C394FE",
						itemStyle: {
							opacity: 0,
						},
						lineStyle: {
							opacity: 0,
						},
						markLine: {
							symbol: 'none',
							data: [
								{
									type: 'average',
									name: '平均数',
									label: {
										normal: {
											show: false,
										},
									},
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: 'dashed',
										color: '#63B2FB',
									},
								},
							],
						},
						// markArea: [
						//   [
						//     {
						//       name: '',
						//       xAxis: data.com_xAxis[0],
						//       yAxis: '6',
						//     },
						//     {
						//       xAxis: data.com_xAxis[data.com_xAxis.length - 1],
						//       yAxis: '10',
						//     },
						//   ],
						// ],
						markArea: {
							silent: true,
							data: [
								[
									{
										name: '',
										yAxis: 6,
										itemStyle: {
											color: '#F2FAFF',
										},
									},
									{
										yAxis: 10,
									},
								],
							]
						}

					},
				],
			};

			var optionSleepDuration2 = {
				color: ['#1890FF', '#c394fe', '#f8b4e7', '#f8b5b5'],
				tooltip: {
					confine: true,
					trigger: 'axis',
					backgroundColor: 'rgba(255, 255, 255, 1)',
					borderColor: 'rgba(24, 144, 255, 0.6)',
					borderWidth: 1,
					spanStyle: {
						color: '#fff',
					},
					formatter: function (params) {
						console.log(params);
						for (var x = 0; x < params.length; i++) {
							if (params[x].data.timeFonts2 == '0') {
								return (
									params[x].name + '<br/>睡眠时长：-<br/>深睡时长：-<br/>浅睡时长：-'
								);
							} else {
								return (
									params[x].name +
									'<br/>睡眠时长：' +
									params[x].data.timeFonts2 +
									'<br/>深睡时长：' +
									params[0].data.timeFonts +
									'<br/>浅睡时长：' +
									params[1].data.timeFonts
								);
							}
						}
					},
				},
				grid: {
					left: '1%',
					right: '1%',
					top: '15%',
					bottom: '1%',
					containLabel: true,
				},
				xAxis: [
					{
						type: 'category',
						data: data.com_xAxis,
						axisLabel: {
							spanStyle: {
								color: '#4D5EA1', //坐标的字体颜色
							},
							// formatter: function (params) {
							//   return params.replace("-", "<br/>");
							// },
						},
						axisLine: {
							lineStyle: {
								color: '#4D5EA1',
							},
						},
						axisTick: {
							show: false,
							alignWithLabel: true,
						},
					},
				],
				yAxis: [
					{
						type: 'value',
						min: 0,
						max: 12,
						logBase: 10,
						splitLine: {
							show: false,
						},
						axisLine: {
							lineStyle: {
								color: '#4D5EA1',
							},
							show: false, //显示y轴，新版本默认没显示
						},
						axisLabel: {
							formatter: '{value}h',
							spanStyle: {
								color: '#4D5EA1', //坐标的字体颜色
							},
						},
						splitNumber: 3,
					},
				],
				series: [
					{
						name: '深睡',
						type: 'bar',
						stack: '1',
						barWidth: data.activeType == 2 ? '20' : '10',
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: deepSleepList,
					},

					{
						name: '浅睡',
						type: 'bar',
						stack: '1',
						barWidth: data.activeType == 2 ? '20' : '10',
						// barWidth: comLen.length > 7 ? "" : 20, //柱图宽度
						data: lightSleepList,
						itemStyle: {
							normal: {
								//柱形图圆角，初始化效果
								barBorderRadius: [4, 4, 0, 0],
							},
						},
					},
					{
						name: '总计',
						type: 'line', // 平均值
						data: [sleepAvg],
						// color: "#C394FE",
						itemStyle: {
							opacity: 0,
						},
						lineStyle: {
							opacity: 0,
						},
						markLine: {
							symbol: 'none',
							data: [
								{
									type: 'average',
									name: '平均数',
									label: {
										normal: {
											show: false,
										},
									},
									lineStyle: {
										//警戒线的样式  ，虚实  颜色
										type: 'dashed',
										color: '#63B2FB',
									},
								},
							],
						},
						markArea_data: [
							[
								{
									name: '',
									xAxis: data.com_xAxis[0],
									yAxis: '6',
								},
								{
									xAxis: data.com_xAxis[data.com_xAxis.length - 1],
									yAxis: '10',
								},
							],
						],
					},
				],
			};

			this.myChart6.setOption(optionSleepDuration);
			window.addEventListener('resize', () => {
				this.myChart6.resize();
			});
		},
		formaTime(minutes) {
			return Math.floor(minutes / 60) + '小时' + (minutes % 60) + '分钟';
		},

	},
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.sleepNameWrap {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin-top: -10px;
}

.sleepName {
	flex: 1;
	width: 40px;
	height: 14px;
	font-size: 10px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #5E6779;
	line-height: 14px;
}

#ec_id_bjbl,
#ec_id_bjbl2,
#ec_id_bjbl3 {
	width: 171px;
	height: 105px;
	margin: 0 auto;
}

#ec_id_lcbj {
	width: 80px;
	height: 90%;
	margin-left: 10px;
}

#ec_id_lcbj2 {
	width: 320px;
	height: 90%;
	margin-left: 10px;
}

#ec_id_smdf {
	width: 160px;
	height: 90%;
}

#ec_id_smsc {
	width: 160px;
	height: 90%;
}

#ec_id_ddfxzs {
	width: 160px;
	height: 90%;
}

.noData {
	width: 100%;
	height: 100%;
	background: #F7F8FA;
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #A5A9BC;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
}

.dCoWrap {
	width: auto;
	white-space: nowrap;
	text-overflow: scroll;
}

.wordsRoll {
	position: relative;
	left: 50px;
	animation: 6s scrolltext linear infinite;
}

@keyframes scrolltext {
	0% {
		left: 0;
		// transform: translateX(-17%);
	}

	35% {
		left: 0;
		// transform: translateX(-17%);
	}

	100% {
		left: -330px;
		// transform: translateX(-150%);
	}

	// 70% {
	//   transform: translateX(150%);
	// }
	// 100% {
	//   transform: translateX(-18%);
	// }
}

.blueShu {
	width: 4px;
	height: 20px;
	background: #1890FF;
	border-radius: 0px 2px 2px 0px;
	content: '';
	position: absolute;
	left: 0;
	top: 18px;
}</style>
